import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Input } from "@/components/ui/input";
import type { PetFormData } from "@/pages/CadastrarPet";

interface Props {
  formData: PetFormData;
  updateField: <K extends keyof PetFormData>(field: K, value: PetFormData[K]) => void;
}

const Comportamento = ({ formData, updateField }: Props) => {
  return (
    <div className="grid gap-5">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="flex items-center justify-between p-4 rounded-xl bg-muted/50">
          <Label htmlFor="sociavel_pets" className="text-sm font-semibold cursor-pointer">
            Sociável com pets?
          </Label>
          <Switch
            id="sociavel_pets"
            checked={formData.sociavel_pets}
            onCheckedChange={(v) => updateField("sociavel_pets", v)}
          />
        </div>

        <div className="flex items-center justify-between p-4 rounded-xl bg-muted/50">
          <Label htmlFor="sociavel_criancas" className="text-sm font-semibold cursor-pointer">
            Sociável com crianças?
          </Label>
          <Switch
            id="sociavel_criancas"
            checked={formData.sociavel_criancas}
            onCheckedChange={(v) => updateField("sociavel_criancas", v)}
          />
        </div>

        <div className="flex items-center justify-between p-4 rounded-xl bg-muted/50">
          <Label htmlFor="agressivo" className="text-sm font-semibold cursor-pointer">
            Agressivo?
          </Label>
          <Switch
            id="agressivo"
            checked={formData.agressivo}
            onCheckedChange={(v) => updateField("agressivo", v)}
          />
        </div>

        <div className="flex items-center justify-between p-4 rounded-xl bg-muted/50">
          <Label htmlFor="medo_chuva" className="text-sm font-semibold cursor-pointer">
            Medo de chuva?
          </Label>
          <Switch
            id="medo_chuva"
            checked={formData.medo_chuva}
            onCheckedChange={(v) => updateField("medo_chuva", v)}
          />
        </div>

        <div className="flex items-center justify-between p-4 rounded-xl bg-muted/50">
          <Label htmlFor="medo_trovao_fogos" className="text-sm font-semibold cursor-pointer">
            Medo de trovão/fogos?
          </Label>
          <Switch
            id="medo_trovao_fogos"
            checked={formData.medo_trovao_fogos}
            onCheckedChange={(v) => updateField("medo_trovao_fogos", v)}
          />
        </div>

        <div className="flex items-center justify-between p-4 rounded-xl bg-muted/50">
          <Label htmlFor="dorme_dentro" className="text-sm font-semibold cursor-pointer">
            Dorme dentro de casa?
          </Label>
          <Switch
            id="dorme_dentro"
            checked={formData.dorme_dentro}
            onCheckedChange={(v) => updateField("dorme_dentro", v)}
          />
        </div>

        <div className="flex items-center justify-between p-4 rounded-xl bg-muted/50">
          <Label htmlFor="aceita_outros_pets" className="text-sm font-semibold cursor-pointer">
            Aceita outros pets?
          </Label>
          <Switch
            id="aceita_outros_pets"
            checked={formData.aceita_outros_pets}
            onCheckedChange={(v) => updateField("aceita_outros_pets", v)}
          />
        </div>

        <div className="flex items-center justify-between p-4 rounded-xl bg-muted/50">
          <Label htmlFor="ja_ficou_hospedado" className="text-sm font-semibold cursor-pointer">
            Já ficou hospedado?
          </Label>
          <Switch
            id="ja_ficou_hospedado"
            checked={formData.ja_ficou_hospedado}
            onCheckedChange={(v) => updateField("ja_ficou_hospedado", v)}
          />
        </div>

        <div className="flex items-center justify-between p-4 rounded-xl bg-muted/50">
          <Label htmlFor="precisa_espaco_cercado" className="text-sm font-semibold cursor-pointer">
            Precisa espaço cercado?
          </Label>
          <Switch
            id="precisa_espaco_cercado"
            checked={formData.precisa_espaco_cercado}
            onCheckedChange={(v) => updateField("precisa_espaco_cercado", v)}
          />
        </div>

        <div className="flex items-center justify-between p-4 rounded-xl bg-muted/50">
          <Label htmlFor="precisa_supervisao_constante" className="text-sm font-semibold cursor-pointer">
            Precisa supervisão constante?
          </Label>
          <Switch
            id="precisa_supervisao_constante"
            checked={formData.precisa_supervisao_constante}
            onCheckedChange={(v) => updateField("precisa_supervisao_constante", v)}
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <Label htmlFor="horario_refeicao" className="text-sm font-semibold">
            Horário de refeição
          </Label>
          <Input
            id="horario_refeicao"
            value={formData.horario_refeicao}
            onChange={(e) => updateField("horario_refeicao", e.target.value)}
            placeholder="Ex: 08h e 18h"
            className="mt-1"
          />
        </div>

        <div>
          <Label htmlFor="horario_passeio" className="text-sm font-semibold">
            Horário de passeio
          </Label>
          <Input
            id="horario_passeio"
            value={formData.horario_passeio}
            onChange={(e) => updateField("horario_passeio", e.target.value)}
            placeholder="Ex: 07h e 19h"
            className="mt-1"
          />
        </div>

        <div>
          <Label htmlFor="objetos_essenciais" className="text-sm font-semibold">
            Objetos essenciais
          </Label>
          <Input
            id="objetos_essenciais"
            value={formData.objetos_essenciais}
            onChange={(e) => updateField("objetos_essenciais", e.target.value)}
            placeholder="Ex: caminha, brinquedo, guia"
            className="mt-1"
          />
        </div>
      </div>
    </div>
  );
};

export default Comportamento;